import _Modal from "antd/es/modal";
import _Button from "antd/es/button";
var _excluded = ["className", "type", "visible", "width", "size", "height", "bodyStyle", "handle", "children", "footer", "okButtonProps", "disabled", "confirmLoading", "title", "okText", "cancelText", "onOk", "onCancel", "onVisibleChange"],
    _excluded2 = ["okText", "className", "cancelText", "cancelabel"],
    _excluded3 = ["icon", "cancelabel"],
    _excluded4 = ["icon", "okButtonProps", "okText", "cancelabel"],
    _excluded5 = ["icon", "okButtonProps", "okText"],
    _excluded6 = ["icon", "okButtonProps", "okText"],
    _excluded7 = ["icon", "okButtonProps", "okText"],
    _excluded8 = ["icon", "okButtonProps", "okText"];

var _this = this;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useMemo, useEffect } from 'react';
import SLSymbolIcon from '../SLSymbolIcon';
import classnames from 'classnames';
import { i18n } from '../_utils/language';
import './index.less';
var sizes;

(function (sizes) {
  sizes[sizes["extraSmall"] = 300] = "extraSmall";
  sizes[sizes["small"] = 480] = "small";
  sizes[sizes["middle"] = 620] = "middle";
  sizes[sizes["large"] = 860] = "large";
})(sizes || (sizes = {}));

var DEFAULTMINHEIGHT = '120px'; // 默认最小高度

var DEFAULTTYPE = 'normal'; // 默认类型

var DEFAULTSIZE = 'middle'; // 默认宽度

var SMALLSIZE = 'small'; // 最小宽度

var SMALLSIZETYPE = ['confirm', 'info', 'warn']; // 最小尺寸的type

var SLModal = function SLModal(props) {
  var className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? DEFAULTTYPE : _props$type,
      visible = props.visible,
      width = props.width,
      _props$size = props.size,
      size = _props$size === void 0 ? SMALLSIZETYPE.includes(props.type || DEFAULTTYPE) ? SMALLSIZE : DEFAULTSIZE : _props$size,
      _props$height = props.height,
      height = _props$height === void 0 ? 'initial' : _props$height,
      bodyStyle = props.bodyStyle,
      handle = props.handle,
      children = props.children,
      footer = props.footer,
      okButtonProps = props.okButtonProps,
      disabled = props.disabled,
      confirmLoading = props.confirmLoading,
      title = props.title,
      okText = props.okText,
      cancelText = props.cancelText,
      onOk = props.onOk,
      onCancel = props.onCancel,
      onVisibleChange = props.onVisibleChange,
      rest = _objectWithoutProperties(props, _excluded); // i18n


  var t = i18n;

  var _useState = useState(visible),
      _useState2 = _slicedToArray(_useState, 2),
      visibleStatus = _useState2[0],
      setVisibleStatus = _useState2[1]; // 控制弹窗显示隐藏


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      innerLoader = _useState4[0],
      setInnerLoader = _useState4[1]; // 内部控制按钮加载动画


  useEffect(function () {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visibleStatus);
  }, [visibleStatus]); // eslint-disable-line react-hooks/exhaustive-deps
  // 更新状态

  useMemo(function () {
    setVisibleStatus(visible);
  }, [visible]);
  /**
   * 关闭
   */

  var hideModal = function hideModal() {
    setVisibleStatus(false);
  };
  /**
   * 显示
   */


  var showModal = function showModal() {
    if (!visibleStatus) {
      setVisibleStatus(true);
    }
  };
  /**
   * 确认按钮
   * @param e
   */


  var onConfirm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!visibleStatus) {
                _context.next = 16;
                break;
              }

              if (!handle) {
                _context.next = 15;
                break;
              }

              setInnerLoader(true);
              _context.prev = 3;
              _context.next = 6;
              return onOk === null || onOk === void 0 ? void 0 : onOk.call(_this, e);

            case 6:
              result = _context.sent;

              if (result !== false) {
                hideModal();
              }

              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

            case 12:
              setInnerLoader(false);
              _context.next = 16;
              break;

            case 15:
              onOk === null || onOk === void 0 ? void 0 : onOk.call(_this, e);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function onConfirm(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * 取消按钮
   * @param e
   */


  var onClose = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!visibleStatus) {
                _context2.next = 14;
                break;
              }

              if (!handle) {
                _context2.next = 13;
                break;
              }

              _context2.prev = 2;
              _context2.next = 5;
              return onCancel === null || onCancel === void 0 ? void 0 : onCancel.call(_this, e);

            case 5:
              result = _context2.sent;

              if (result !== false) {
                hideModal();
              }

              _context2.next = 11;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);

            case 11:
              _context2.next = 14;
              break;

            case 13:
              onCancel === null || onCancel === void 0 ? void 0 : onCancel.call(_this, e);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 9]]);
    }));

    return function onClose(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var footerNode = function footerNode() {
    if (footer === false || typeof footer === 'string' || typeof footer === 'number' || footer instanceof Array || /*#__PURE__*/React.isValidElement(footer)) {
      return footer;
    }

    var f = footer;
    return /*#__PURE__*/React.createElement("div", {
      className: 'sl-modal-footer'
    }, /*#__PURE__*/React.createElement("div", null, f === null || f === void 0 ? void 0 : f.left), /*#__PURE__*/React.createElement("div", null, (f === null || f === void 0 ? void 0 : f.right) ? f === null || f === void 0 ? void 0 : f.right : /*#__PURE__*/React.createElement(React.Fragment, null, type !== 'info' && /*#__PURE__*/React.createElement(_Button, {
      onClick: onClose
    }, cancelText || t('SLModal.default.cacelText')), /*#__PURE__*/React.createElement(_Button, _extends({
      type: "primary",
      danger: type === 'warn',
      disabled: disabled,
      loading: innerLoader || confirmLoading
    }, okButtonProps, {
      onClick: disabled || innerLoader || confirmLoading ? undefined : onConfirm
    }), okText || t('SLModal.default.okText')))));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, handle && /*#__PURE__*/React.createElement("span", {
    onClick: showModal
  }, handle), /*#__PURE__*/React.createElement(_Modal, _extends({
    className: classnames('sl-modal', className, title === false ? 'sl-modal-noHeader' : ''),
    width: width || sizes[size],
    title: title,
    visible: visibleStatus,
    bodyStyle: _objectSpread({
      minHeight: DEFAULTMINHEIGHT,
      height: height,
      overflowY: 'auto'
    }, bodyStyle),
    onOk: onConfirm,
    onCancel: onClose,
    closeIcon: /*#__PURE__*/React.createElement(SLSymbolIcon, {
      icon: "iconclose-small",
      style: {
        fontSize: 24,
        color: '#474F5E'
      }
    }),
    centered: true
  }, rest, {
    footer: footerNode()
  }), children));
};
/**
 * 为dialog方法新增属性
 */


/**
 * Dialog
 */
export var Dialog = function Dialog(_ref3) {
  var okText = _ref3.okText,
      className = _ref3.className,
      cancelText = _ref3.cancelText,
      _ref3$cancelabel = _ref3.cancelabel,
      cancelabel = _ref3$cancelabel === void 0 ? false : _ref3$cancelabel,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  // i18n
  var t = i18n;
  return _Modal.confirm(_objectSpread({
    className: classnames('sl-modal-confirm', className),
    okText: okText || t('SLModal.default.okText'),
    cancelText: cancelText || t('SLModal.default.cacelText'),
    cancelButtonProps: {
      style: cancelabel === true ? {} : {
        display: 'none'
      }
    },
    autoFocusButton: null,
    centered: true
  }, rest));
};
/**
 * 确认
 */

export var Confirm = function Confirm(_ref4) {
  var _ref4$icon = _ref4.icon,
      icon = _ref4$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    icon: "iconinfo-circle"
  }) : _ref4$icon,
      _ref4$cancelabel = _ref4.cancelabel,
      cancelabel = _ref4$cancelabel === void 0 ? true : _ref4$cancelabel,
      rest = _objectWithoutProperties(_ref4, _excluded3);

  return Dialog(_objectSpread({
    icon: icon,
    cancelabel: cancelabel
  }, rest));
};
/**
 * 危险操作确认弹窗
 */

export var Danger = function Danger(props) {
  var _props$icon = props.icon,
      icon = _props$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    style: {
      color: '#F86140'
    },
    icon: "iconExclamationCircle1"
  }) : _props$icon,
      okButtonProps = props.okButtonProps,
      okText = props.okText,
      _props$cancelabel = props.cancelabel,
      cancelabel = _props$cancelabel === void 0 ? true : _props$cancelabel,
      rest = _objectWithoutProperties(props, _excluded4); // i18n


  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    cancelabel: cancelabel,
    okButtonProps: _objectSpread({
      danger: true
    }, okButtonProps),
    okText: okText || t('SLModal.danger.okText')
  }, rest));
};
/**
 * 成功
 */

export var Success = function Success(_ref5) {
  var _ref5$icon = _ref5.icon,
      icon = _ref5$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    icon: "iconCheckCircle"
  }) : _ref5$icon,
      okButtonProps = _ref5.okButtonProps,
      okText = _ref5.okText,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default'
    }, okButtonProps)
  }, rest));
};
/**
 * 信息
 */

export var Info = function Info(_ref6) {
  var _ref6$icon = _ref6.icon,
      icon = _ref6$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    icon: "iconinfo-circle"
  }) : _ref6$icon,
      okButtonProps = _ref6.okButtonProps,
      okText = _ref6.okText,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default'
    }, okButtonProps)
  }, rest));
};
/**
 * 警告
 */

export var Warn = function Warn(_ref7) {
  var _ref7$icon = _ref7.icon,
      icon = _ref7$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    icon: "iconExclamationCircle"
  }) : _ref7$icon,
      okButtonProps = _ref7.okButtonProps,
      okText = _ref7.okText,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default'
    }, okButtonProps)
  }, rest));
};
/**
 * 错误
 */

export var Error = function Error(_ref8) {
  var _ref8$icon = _ref8.icon,
      icon = _ref8$icon === void 0 ? /*#__PURE__*/React.createElement(SLSymbolIcon, {
    className: "anticon",
    icon: "iconCloseCircle"
  }) : _ref8$icon,
      okButtonProps = _ref8.okButtonProps,
      okText = _ref8.okText,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  // i18n
  var t = i18n;
  return Dialog(_objectSpread({
    icon: icon,
    okText: okText || t('SLModal.info.okText'),
    okButtonProps: _objectSpread({
      type: 'default'
    }, okButtonProps)
  }, rest));
};
SLModal.confirm = Confirm;
SLModal.danger = Danger;
SLModal.success = Success;
SLModal.info = Info;
SLModal.warn = Warn;
SLModal.error = Error;
export default SLModal;